import { LessonTaskStepWithLessonAndTask } from '../../main/types/asset/lesson.types.ts';
import { KeyedWritingPath } from '../../main/types/asset/writing-path.types.ts';
import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';
import { getWritingPathsUtil } from '../../main/utils/asset/writing-paths.util.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectCurrentWritingPath = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  (currentStep: LessonTaskStepWithLessonAndTask): KeyedWritingPath | null => {
    const { task, step } = currentStep;
    if (!step || !task) return null;

    const letter = getLessonsUtil().getStepLetter(task, step);
    if (!letter) return null;

    const writingPath = getWritingPathsUtil().getWritingPath(letter);
    if (!writingPath) return null;

    return writingPath;
  }
);
